import { render, staticRenderFns } from "./RingCentral.vue?vue&type=template&id=9de230b8&scoped=true&"
import script from "./RingCentral.vue?vue&type=script&lang=js&"
export * from "./RingCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de230b8",
  null
  
)

export default component.exports